import { CheckboxGroup, EnumDropdown, ModalFormButton } from 'framework/form';
import { useAuthorization } from 'framework/authorization';
import {
  AUSTIN_OFFICE_ID,
  EMPLOYEE_CONTRACT_ASSIGMENT_ALIAS,
  EMPLOYEE_CONTRACT_ASSIGMENT_TYPES,
  KRAKOW_OFFICE_ID,
  MINSK_OFFICE_ID,
  OFFICE_NAMES,
  PositionDropdown,
} from 'domain/shared/employee';
import { BusinessFunctionDropdown } from 'domain/shared/businessFunction';
import { EMPLOYEE_COMPETENCY_LEVEL } from 'domain/shared/performanceMeasurement';
import usePositionSlotsService from '../usePositionSlotsService';
import { POSITION_SLOT_CREATE, POSITION_SLOT_WORKER_TYPE, POSITION_SLOT_WORKER_TYPE_CREATE_LABELS } from '../constants';
import { POSITION_SLOT_OFFICES_CHECKBOX_SX } from 'domain/shared/employee/office';
import PositionSlotTechnologyDropdown from '../input/PositionSlotTechnologyDropdown';
import { getCreatePositionSlotValidationSchema } from '../validation/positionSlotValidation';

const OFFICE_OPTIONS = [
  { value: String(AUSTIN_OFFICE_ID), label: OFFICE_NAMES['Austin-1'] },
  { value: String(MINSK_OFFICE_ID), label: OFFICE_NAMES['Minsk-1'] },
  { value: String(KRAKOW_OFFICE_ID), label: OFFICE_NAMES['Krakow-1'] },
];

const CreatePositionSlotFormFields = () => {
  return (
    <>
      <PositionDropdown source="specializationId" label="Specialization" isRequired />
      <PositionSlotTechnologyDropdown />
      <EnumDropdown source="competencyLevel" label="Competency level" options={EMPLOYEE_COMPETENCY_LEVEL} />
      <BusinessFunctionDropdown source="businessFunctionId" label="Business function" isRequired />
      <CheckboxGroup
        source="officeIds"
        label="Location"
        isRequired
        options={OFFICE_OPTIONS}
        sx={POSITION_SLOT_OFFICES_CHECKBOX_SX}
      />
      <EnumDropdown source="workerType" label="Category" options={POSITION_SLOT_WORKER_TYPE_CREATE_LABELS} isRequired />
      <EnumDropdown source="workRateType" label="FTE" options={EMPLOYEE_CONTRACT_ASSIGMENT_TYPES} isRequired />
    </>
  );
};

const CreatePositionSlotModalButton = ({ onSuccess }: { onSuccess: () => void }) => {
  const { isGranted } = useAuthorization();
  const { createPositionSlot } = usePositionSlotsService();

  if (!isGranted(POSITION_SLOT_CREATE)) {
    return null;
  }

  return (
    <ModalFormButton
      label="Create position"
      formTitle="Create position slot"
      getValidationSchemaFunc={getCreatePositionSlotValidationSchema}
      submitFormFunc={createPositionSlot}
      initialData={{
        workerType: POSITION_SLOT_WORKER_TYPE.STAFF,
        workRateType: EMPLOYEE_CONTRACT_ASSIGMENT_ALIAS.FULL_TIME,
        officeIds: [String(MINSK_OFFICE_ID)],
      }}
      afterSubmit={{
        execute: onSuccess,
        message: 'Position slot has been successfully created.',
      }}
    >
      <CreatePositionSlotFormFields />
    </ModalFormButton>
  );
};

export default CreatePositionSlotModalButton;
